import { getCurrentLanguage } from '@modernloop/i18n';
import { da, de, enGB, enUS, es, fr, frCA, it, ja, ko, ptBR, zhCN, zhTW } from 'date-fns/locale';
import type { Locale } from 'date-fns';

interface DateFnsLocaleByLanguage {
  readonly [language: string]: Locale;
}

const LANGUAGE_TO_DATE_FNS_LOCALE: DateFnsLocaleByLanguage = {
  'en-US': enUS,
  'en-GB': enGB,
  'en-sloth': enUS,
  'es-ES': es,
  'es-419': es,
  'fr-FR': fr,
  'fr-CA': frCA,
  'de-DE': de,
  'da-DK': da,
  'it-IT': it,
  'ja-JP': ja,
  'ko-KR': ko,
  'pt-BR': ptBR,
  'zh-CN': zhCN,
  'zh-TW': zhTW,
};

/** Resolve a date-fns Locale for duration/word formatting from the active app language. */
export const getDateFnsLocale = (language: string = getCurrentLanguage()): Locale =>
  LANGUAGE_TO_DATE_FNS_LOCALE[language] ?? enUS;
